import { useState, useEffect } from "react";
import { myFbollection, firestore } from "../Utils/fbFunctionInit";

function SelectedPtFromFb(props) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const ptMedRN = props.ptMedRN;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await firestore
          .collection(myFbollection)
          .where("value.ptMedRN", "==", ptMedRN)
          .get();
        const data = querySnapshot.docs.map((doc) => doc.data())[0];
        setData(data);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchData();
  }, [ptMedRN]);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <div>
      {data && (
        <div>
          <p>{data.value.ptName}</p>
        </div>
      )}
    </div>
  );
}

export function SelectFullPt(ptMedRN) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await firestore
          .collection(myFbollection)
          .where("value.ptMedRN", "==", ptMedRN)
          .get();
        const data = querySnapshot.docs.map((doc) => doc.data())[0];
        setData(data);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchData();
  }, [ptMedRN]);

  if (loading) {
    return "Loading...";
  }

  if (error) {
    return error.message;
  }

  return data.value;
}

export default SelectedPtFromFb;
